import React, { useEffect, useState } from "react";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { getAllCustomerType } from "../../../actions/CustomerTypeActions";
import { getVehicleByCustomerId } from "../../../actions/VehicleActions";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import { getAllCustomerLocal } from "../../../actions/CustomerActions";


const Step1 = (props) => {

    const dispatch = useDispatch();
    const { data, handleChange, next, setFormData, formData, setCustomerVehicles } = props;
    useEffect(() => {
        dispatch(getAllCustomerLocal(null, 99999));
    }, []);

    const customers = useSelector(state => state?.customer?.customers);
    const customerVehicles = useSelector(state => state?.vehicle?.customerVehicles);
    const loading = useSelector(state => state?.loading?.addEditLoading);

    useEffect(() => {
        // 'data',data);
        if (data && Object.keys(data).length > 0) {
            setFormData({
                ...formData,
                'customer_name': data.name,
                'customer_email': data.email && Object.keys(data.email).length > 0 ? data.email : '',
                'customer_mobile': data.mobile && Object.keys(data.mobile).length > 0 ? data.mobile : '',
                'customer_phone': data.phone && Object.keys(data.phone).length > 0 ? data.phone : '',
                'customer_fax': data.x_Fax && Object.keys(data.x_Fax).length > 0 ? data.x_Fax : '',
                'customer_trn_number': data.x_TRN_no && Object.keys(data.x_TRN_no).length > 0 ? data.x_TRN_no : '',
                'customer_address': data.x_FullAddress && Object.keys(data.x_FullAddress).length > 0 ? data.x_FullAddress : ''
            });
            dispatch(getVehicleByCustomerId(data?.customer_id));
        }
    }, [data])
    useEffect(() => {
        if (customerVehicles && Object.keys(customerVehicles).length > 0) {
            setCustomerVehicles(customerVehicles);
        }
    }, [customerVehicles])

    const [searchString, setSearchString] = useState('');

    const handleOnSearch = (string) => {
        setSearchString(string);
        setFormData({
            ...formData,
            'customer_mobile': string,
        });
    }

    let filteredData = '';
    if (customers && Array.isArray(customers) && customers.length > 0) {
        filteredData = customers.filter((item) => {
            // Convert the item to a string and make it lowercase for case-insensitive search
            const itemString = JSON.stringify(item).toLowerCase();
            // Check if the itemString includes the searchQuery
            return itemString.includes(searchString.toLowerCase());
        });
    } else {
        // Handle the case when customers is not an array or is empty
        filteredData = [];
    }

    // const handleOnSearch = (string, results) => {
    //     // onSearch will have as the first callback parameter
    //     // the string searched and for the second the results.
    //     // string, results)
    //     setFormData({
    //         ...formData,
    //         'customer_mobile': string,
    //     });
    // }

    const handleOnSelect = (item) => {
        setFormData({
            ...formData,
            'customer_name': item.name,
            'customer_email': item.email && Object.keys(item.email).length > 0 ? item.email : '',
            'customer_mobile': item.mobile && Object.keys(item.mobile).length > 0 ? item.mobile : '',
            'customer_phone': item.phone && Object.keys(item.phone).length > 0 ? item.phone : '',
            'customer_fax': item.x_Fax && Object.keys(item.x_Fax).length > 0 ? item.x_Fax : '',
            'customer_trn_number': item.x_TRN_no && Object.keys(item.x_TRN_no).length > 0 ? item.x_TRN_no : '',
            'customer_address': item.x_FullAddress && Object.keys(item.x_FullAddress).length > 0 ? item.x_FullAddress : ''
        });
        dispatch(getVehicleByCustomerId(item.customer_id));
    }
    const handelOnClear = (item) => {
        // 'item', item);
        setFormData({
            'customer_name': "",
            'customer_email': "",
            'customer_mobile': "",
            'customer_phone': "",
            'customer_fax': "",
            'customer_trn_number': "",
            'customer_address': ""
        });
        setCustomerVehicles('');
    }
    return (
        <>
            <div className="d-flex align-items-center mt-8">
                <h2 className="intro-y fs-lg fw-medium me-auto">
                    Investigation
                </h2>
            </div>
            {
                loading ?
                    <ThreeDots
                        height="80"
                        width="80"
                        radius="9"
                        color="#2d3748"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                        wrapperClassName=""
                        visible={loading}
                    /> :
                    <span>
                        <div className="intro-y box py-10 py-sm-20 mt-5">
                            <div className="wizard d-flex flex-column flex-lg-row justify-content-center px-8">
                                <div className="intro-x text-lg-center d-flex align-items-center d-lg-block flex-1 z-10">
                                    <button className="w-12 h-12 rounded-circle fs-lg btn btn-primary">1</button>
                                    <div className="w-lg-40 fw-medium fs-lg mt-lg-3 ms-3 mx-lg-auto">Customer Details</div>
                                </div>
                                <div className="intro-x text-lg-center d-flex align-items-center mt-5 mt-lg-0 d-lg-block flex-1 z-10">
                                    <button className="w-12 h-12 rounded-circle fs-lg btn text-gray-600 bg-gray-200 dark-bg-dark-1">2</button>
                                    <div className="w-lg-40 fs-lg mt-lg-3 ms-3 mx-lg-auto text-gray-700 dark-text-gray-600">Vehicle Details</div>
                                </div>
                                <div className="intro-x text-lg-center d-flex align-items-center mt-5 mt-lg-0 d-lg-block flex-1 z-10">
                                    <button className="w-12 h-12 rounded-circle fs-lg btn text-gray-600 bg-gray-200 dark-bg-dark-1">3</button>
                                    <div className="w-lg-40 fs-lg mt-lg-3 ms-3 mx-lg-auto text-gray-700 dark-text-gray-600">Products Added</div>
                                </div>
                                <div className="wizard__line d-none d-lg-block w-2/3 bg-gray-200 dark-bg-dark-1 position-absolute mt-5"></div>
                            </div>
                            <div className="px-5 px-sm-20 mt-10 pt-10 border-top border-gray-200 dark-border-dark-5">
                                <div className="fw-medium fs-base">Customer's Information:</div>
                                <div className="grid columns-12 gap-4 gap-y-5 mt-5">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">Mobile No <span className="text-theme-6">*</span> :</label>
                                        <ReactSearchAutocomplete
                                            items={filteredData && filteredData}
                                            inputSearchString={formData?.customer_mobile}
                                            onSearch={(e) => handleOnSearch(e)}
                                            inputDebounce={0}
                                            onSelect={handleOnSelect}
                                            styling={{
                                                backgroundColor: '.auto-input:focus' ? '#fff' : '#fff',
                                                border: '.auto-input:focus' ? '1px solid #e2e8f0' : '1px solid #e2e8f0',
                                                borderColor: '.auto-input:focus' ? '#e2e8f0' : '#e2e8f0 !important',
                                                boxShadow: '.auto-input:focus' ? '0 0 0 0.25rem rgba(28, 63, 170, .25)' : '0 1px 2px 0 rgba(0, 0, 0, .05)',
                                                color: '.auto-input:focus' ? '#2d3748' : '#2d3748',
                                                borderRadius: '0.375rem',
                                                placeholderColor: '#a0aec0',
                                                fontSize: '14',
                                                '&:hover': { borderColor: '#e2e8f0' }
                                            }}
                                            className="auto-input"
                                            placeholder="Enter Mobile No."
                                            fuseOptions={{
                                                keys: ["customer_id", "mobile"],
                                                shouldSort: false,
                                            }}
                                            resultStringKeyName="mobile"
                                            autoComplete={false}
                                            onClear={handelOnClear}
                                        />
                                        {/* <input id="phone" name="customer_phone" type="text" className="form-control" onChange={handleChange} placeholder="Enter Phone No." /> */}
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Name <span className="text-theme-6">*</span> :</label>
                                        <input id="name" value={formData?.customer_name} name="customer_name" type="text" className="form-control h-45px" onChange={handleChange} placeholder="Enter Name" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="email" className="form-label">Email :</label>
                                        <input id="email" value={formData?.customer_email} name="customer_email" type="text" className="form-control h-45px" onChange={handleChange} placeholder="Enter Email" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="phone" className="form-label">Phone No. :</label>
                                        <input id="phone" value={formData?.customer_phone} name="customer_phone" type="text" className="form-control h-45px" onChange={handleChange} placeholder="Enter Phone No." />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="fax" className="form-label">CRTN # :</label>
                                        <input id="fax" value={formData?.customer_fax} name="customer_fax" type="text" className="form-control h-45px" onChange={handleChange} placeholder="Enter CRTN #" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="trn" className="form-label">Vat TRN #<span className="text-theme-6">*</span> :</label>
                                        <input id="trn" value={formData?.customer_trn_number} name="customer_trn_number" type="text" className={`form-control h-45px`} onChange={handleChange} placeholder="Enter Vat TRN #" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="address" className="form-label">Address :</label>
                                        <input id="address" value={formData?.customer_address} name="customer_address" type="text" className="form-control h-45px" onChange={handleChange} placeholder="Enter Address" />
                                    </div>
                                    <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                                        <button className="btn btn-primary w-24 ms-2" onClick={next}>Next</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
            }
        </>
    );
};
export default Step1;